export default class ReservationErrorHandled extends Error {
}